import { render, staticRenderFns } from "./qqCallback.vue?vue&type=template&id=c985b434&scoped=true"
import script from "./qqCallback.vue?vue&type=script&lang=js"
export * from "./qqCallback.vue?vue&type=script&lang=js"
import style0 from "./qqCallback.vue?vue&type=style&index=0&id=c985b434&prod&scoped=true&lang=css"
import style1 from "./qqCallback.vue?vue&type=style&index=1&id=c985b434&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c985b434",
  null
  
)

export default component.exports